import { CurrencyPipe, DatePipe, JsonPipe, NgClass, NgFor, NgIf} from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { PropertyService } from '../../_services/properties/property.service';
import { InrShortPipe } from '../../_pipes/indian-currency.pipe';
// import { PropertySearchPipe } from '../../_pipes/property-search.pipe';
import { NumberformatDirective } from '../../_pipes/numberformat.directive';
import { NumberFormatPipe } from '../../_pipes/number-format.pipe';
import { ToastService } from '../../_services/toast.service';
import { LoaderService } from '../../_services/loader.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../_services/auth.service';

interface MicroMarket {
  micromarketName: string;
  cluster: string;
}

interface Property {
  _id: string;
  name: string;
  builder: string;
  priceUnit: string;
  propertyType: string;
  bedrooms: number;
  landArea: number;
  location: string;
  shortDescription: string;
  isSoldOut: boolean;
  isLiked: boolean;
  microMarket?: MicroMarket;
  createdAt?: string;
  updatedAt?: string;
  price?: PriceItem[];
  superBuiltUpArea?: number;
  propUpdatedBy:object

  // ... other fields
}

export type PriceItem = {
  _id: string;
  bhkType: string;
  price: number;
  areaInSq: number;
  averagePrice: number;
  propertyStructureType?: string;
};

type ModalTab = 'gallery' | 'plans' | 'video';

@Component({
  selector: 'app-properties',
  imports: [
    NgFor,
    NgIf,
    NgClass,
    FormsModule,
    RouterModule,
    // PropertySearchPipe,
    NumberFormatPipe,
    DatePipe,
  ],
  providers: [InrShortPipe],
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.scss'],
  standalone: true,
})
export class PropertiesComponent {
  filteredProperties: Property[] = [];
  properties: Property[] = [];
  searchTerm: any;
  searchTimeout: any;
  meta: any = {};
  activeDropdown: string | null = null;
  sortDirection: 'asc' | 'desc' = 'desc';
  // Pagination
  currentPage: number = 1;
  itemsPerPage: number = 20;   // number of properties per page
  totalPages: number = 0;

  activeTab: ModalTab = 'gallery';
  showDeleteModal = false;
  propertyIdToDelete: string | null = null;
  constructor(
    private router: Router,
    private readonly _PS: PropertyService,
    private inrShortPipe: InrShortPipe,
    private _NS: ToastService,
    private loader: LoaderService,
    private http: HttpClient,
    private _AS : AuthService
  ) {}

  ngOnInit(): void {
    this.getAllProperties();
  }
  totalProperty:any

  getPrices(property: Property): PriceItem[] {
    return property?.price ?? [];
  }

  getAllProperties(page: number = 1) {

    const params = new HttpParams()
      .set('page', page)
      .set('limit', this.itemsPerPage)
      .set('search', this.searchTerm?.trim() || '');

    this.http.get(`${environment.api_URL}/property`, { params })
      .subscribe((res: any) => {

        if (res?.status) {

          this.properties = (res.data || []).sort((a: any, b: any) => {
            return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
          });

          this.filteredProperties = [...this.properties];

          this.meta = res.meta || {};
          this.currentPage = this.meta.page;
          this.totalPages = this.meta.totalPages;
        }

      });
  }

  // Search
  onSearchChange() {

    clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      this.currentPage = 1;
      this.getAllProperties(1);
    }, 400);

  }

  cleanCluster(cluster?: string): string {
    if (!cluster) return '';
    return cluster.replace(/\(C\d+\)/g, '').trim();
  }
  

  changePage(page: number) {

    if (page < 1 || page > this.totalPages) return;

    this.getAllProperties(page);

  }

  toggleDropdown(id: string) {
    this.activeDropdown = this.activeDropdown === id ? null : id;
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    const target = event.target as HTMLElement;

    if (!target.closest('.relative')) {
      this.activeDropdown = null;
    }
    if (!target.closest('.action-dropdown')) {
      this.activeDropdown = null;
    }
  }

  sortByUpdatedAt() {

    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';

    this.filteredProperties.sort((a: any, b: any) => {

      const dateA = new Date(a.updatedAt).getTime();
      const dateB = new Date(b.updatedAt).getTime();

      return this.sortDirection === 'asc'
        ? dateA - dateB
        : dateB - dateA;

    });

  }

  // Method to handle when the main form submits a new property
  addProperty(newProperty: Property): void {
    this.properties.unshift(newProperty); // Add to the beginning of the list
    this.onSearchChange(); // Update the filtered and paginated properties
  }

  viewDetails(property: Property): void {
    this.router.navigate(['admin/property/details'], {
      queryParams: {
        id: property._id,
        mode: 'details',
      },
    });
  }
  navigateToGallery(property: Property): void {
    this.router.navigate(['admin/property/image-upload', property._id], {
      queryParams: {
        mode: 'gallery',
      },
    });
  }

  editProperty(property: any) {
    this.router.navigate(['admin/property/edit', property._id]);
  }

  // onSearchChange() {}
  toggleFilters() {}

  formatPriceDisplay(priceData: any): string {
    if (!priceData) return 'N/A';
    if (Array.isArray(priceData)) {
      if (priceData.length === 0) return 'N/A';
      const values = priceData
        .map((p) => Number(p.price))
        .filter((v) => !isNaN(v));
      if (values.length === 0) return 'N/A';

      const min = Math.min(...values);
      const max = Math.max(...values);
      if (values.length === 1 || min === max) {
        return this.inrShortPipe.transform(min);
      }
      return `${this.inrShortPipe.transform(
        min
      )} - ${this.inrShortPipe.transform(max)}`;
    }
    return this.inrShortPipe.transform(priceData);
  }
  isImageModalOpen = false;
  isClosing = false;
  selectedPro: any;
  closeModal() {
    this.isClosing = true;
    // Wait 300ms (matching the CSS duration) then remove from DOM
    setTimeout(() => {
      this.isImageModalOpen = false;
      this.isClosing = false;
    }, 300);
  }
  uploadedImages: any = [];
  showGallery(property: any) {
    this.selectedPro = property;
    this.activeTab = 'gallery';
    this.isImageModalOpen = true;
    this.uploadedImages = property.galleryImage;
  }
  goToUpload() {}
  onDeleteImage(propertyId: string, imageUrl: string, type: any) {
    const typeMapping: Record<
      string,
      'planImage' | 'galleryImage' | 'propertyVideo'
    > = {
      plan: 'planImage',
      gallery: 'galleryImage',
      video: 'propertyVideo',
    };

    const ImageType = typeMapping[type];
    if (confirm('Are you sure you want to delete this image?')) {
      this._PS.deleteImage(propertyId, imageUrl, ImageType).subscribe({
        next: (response) => {
          this._NS.success(response.message);
          this.showGallery(response.data);
        },
        error: (err) => {
          // Show this to the user via a Toast or Alert
          alert(err.message);
        },
      });
    }
  }

  openDeleteModal(id: string) {
    this.propertyIdToDelete = id;
    this.showDeleteModal = true;
  }
  deleteReason = '';
  deleteReasonError = false;
  deleteProperty() {
    if (!this.deleteReason.trim()) {
      this.deleteReasonError = true;
      return;
    }
    this.deleteReasonError = false;
    if (this.propertyIdToDelete) {
      this.loader.show()
      this._PS.deleteProperty(this.propertyIdToDelete, this.deleteReason).subscribe({
        next: (response) => {
          this.showDeleteModal = false;
          this._NS.success(response.message);
          this.getAllProperties();
          this.loader.hide()
          this.deleteReason = ''
        },
        error: (err) => {
          this.showDeleteModal = false;
          this._NS.error(err.message);
          this.loader.hide()
        },
      });
    }
  }
  getVisiblePages(): number[] {

  const pages: number[] = [];
  const start = Math.max(1, this.currentPage - 2);
  const end = Math.min(this.totalPages, this.currentPage + 2);

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
}

formateUser(user:any){
  if (!user) return '_';
  const nameParts = user.name.split(' ');
  const formattedName = nameParts.length > 1 
    ? `${nameParts[0]} ${nameParts[1]}` 
    : user.name;

  return `${formattedName} | ${user.role}`;
}
searchItem(){
    this.loader.show()
    this._PS.searchProperty(this.searchTerm).subscribe({
      next: (response:any) => {
        if(response.data.length){
          this.properties = response.data || [];
          this.filteredProperties = [...this.properties];
          this.meta = response.meta || {};
          this.currentPage = this.meta.page;
          this.totalPages = this.meta.totalPages;
        } else{
          this.getAllProperties();
        }
        this.loader.hide()
      },
      error: (err:any) => {
        this.showDeleteModal = false;
        this._NS.error(err.message);
        this.loader.hide()
      },
    });
}
isRoteHasPermissions(perm:any){
  return this._AS.hasPermission(perm)
}
isExporting = false;

exportPropertiesToExcel(): void {
  this.isExporting = true;
  this.http.get(`${environment.api_URL}/property/export`, {
    responseType: 'blob',
    observe: 'response',
  }).subscribe({
    next: (response) => {
      const blob = response.body as Blob;
      const contentDisposition = response.headers.get('content-disposition');
      const filenameMatch = contentDisposition?.match(/filename=(.+\.xlsx)/);
      const filename = filenameMatch ? filenameMatch[1] : `properties-${Date.now()}.xlsx`;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
      this.isExporting = false;
    },
    error: (err) => {
      console.error('Export failed', err);
      this.isExporting = false;
      // optionally show a toast/snackbar here
    },
  });
}
}

